

import apiService from '@/api/request';
import {
  ACTIVESYMBOL,
  AGENTCONFIG
} from '../mutation-type';
export const getDefaultSymbol = async ({ commit }) => {
  const res = await apiService.product();
  console.log("activeSymbolItem 3", res)
  if (res.status === 1) {
    commit(ACTIVESYMBOL, res.data.productList[0]);
  }
};
export const getAgentConfig = async ({ commit }) => {
  const res = await apiService.AppInfo();
  if (res.status === 1) {
    commit(AGENTCONFIG, res.data.agentConfig);
  }
};
